import axios from 'axios'

export default class AreaAcao {
  constructor (tokenBearer, url, id) {
    this.url = url
    this.tokenBearer = tokenBearer
    this.urlDownload = `${url}/api/unimed/areaAcao/exportar/${id}`
    this.id = id
  }

  getAreaAcao () {
    let url = `${this.url}/api/unimed/areaAcao/${this.id}`
    return new Promise(async (resolve, reject) => {
      let optionsAreaAcao = {
        method: 'get',
        url,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let responseAreaAcao = await axios(optionsAreaAcao)
        resolve(responseAreaAcao)
      } catch (err) {
        reject(err)
      }
    })
  }

  postAreaAcao (municipiosId) {
    let url = `${this.url}/api/unimed/areaAcao/municipios/${this.id}`
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'post',
        url,
        headers: {
          'Authorization': this.tokenBearer
        },
        data: municipiosId
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  deleteAreaAcao (municipiosId) {
    let url = `${this.url}/api/unimed/areaAcao/municipios/${this.id}`
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'delete',
        url,
        headers: {
          'Authorization': this.tokenBearer
        },
        data: municipiosId
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  getAreaAcaoFiltrada (args = '') {
    let url = `${this.url}/api/unimed/areaAcao/municipios/${this.id}`
    return new Promise(async (resolve, reject) => {
      let optionsAreaAcao = {
        method: 'get',
        url: `${url}?${args}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let responseAreaAcao = await axios(optionsAreaAcao)
        resolve(responseAreaAcao)
      } catch (err) {
        reject(err)
      }
    })
  }

  exportar (args) {
    return new Promise(async (resolve, reject) => {
      let optionsAreaAcao = {
        method: 'get',
        url: `${this.urlDownload}?${args}`,
        headers: {
          'Authorization': this.tokenBearer
        },
        responseType: 'blob'
      }

      try {
        let response = await axios(optionsAreaAcao)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  getMunicipiosComPilares () {
    return axios({
      method: 'get',
      url: `${this.url}/api/unimed/areaAcao/${this.id}/pilares`,
      headers: { 'Authorization': this.tokenBearer }
    })
  }

  postMunicipiosPilar (pilar, municipioIds) {
    return axios({
      method: 'post',
      url: `${this.url}/api/unimed/areaAcao/municipios/${this.id}/pilar/${pilar}`,
      headers: { 'Authorization': this.tokenBearer },
      data: municipioIds
    })
  }

  deleteMunicipiosPilar (pilar, municipioIds) {
    return axios({
      method: 'delete',
      url: `${this.url}/api/unimed/areaAcao/municipios/${this.id}/pilar/${pilar}`,
      headers: { 'Authorization': this.tokenBearer },
      data: municipioIds
    })
  }

  getTextosExplicativos () {
    return axios({
      method: 'get',
      url: `${this.url}/api/unimed/areaAcao/textoExplicativo`,
      headers: { 'Authorization': this.tokenBearer }
    })
  }

  putTextoExplicativo (pilar, descricao) {
    return axios({
      method: 'put',
      url: `${this.url}/api/unimed/areaAcao/textoExplicativo/${pilar}`,
      headers: { 'Authorization': this.tokenBearer, 'Content-Type': 'application/json' },
      data: JSON.stringify(descricao)
    })
  }

  getInfoComplementar (municipioId) {
    return axios({
      method: 'get',
      url: `${this.url}/api/unimed/areaAcao/${this.id}/infoComplementar/${municipioId}`,
      headers: { 'Authorization': this.tokenBearer }
    })
  }

  putInfoComplementar (municipioId, dto) {
    return axios({
      method: 'put',
      url: `${this.url}/api/unimed/areaAcao/${this.id}/infoComplementar/${municipioId}`,
      headers: { 'Authorization': this.tokenBearer },
      data: dto
    })
  }

  postAnexo (municipioId, arquivo) {
    const formData = new FormData()
    formData.append('arquivo', arquivo)
    return axios({
      method: 'post',
      url: `${this.url}/api/unimed/areaAcao/${this.id}/infoComplementar/${municipioId}/anexo`,
      headers: { 'Authorization': this.tokenBearer, 'Content-Type': 'multipart/form-data' },
      data: formData
    })
  }

  getAnexo (municipioId) {
    return axios({
      method: 'get',
      url: `${this.url}/api/unimed/areaAcao/${this.id}/infoComplementar/${municipioId}/anexo`,
      headers: { 'Authorization': this.tokenBearer },
      responseType: 'blob'
    })
  }

  deleteAnexo (municipioId) {
    return axios({
      method: 'delete',
      url: `${this.url}/api/unimed/areaAcao/${this.id}/infoComplementar/${municipioId}/anexo`,
      headers: { 'Authorization': this.tokenBearer }
    })
  }
}
